import { defineStyle } from "@chakra-ui/react";

export const ChatViewStyles = () => {
  return {
    mainContainer: defineStyle({
      marginBottom: "8px",
    }),
    practiceUserContainer: defineStyle({
      marginY: "0px",
      marginLeft: { base: "-10px", md: "0px" },
      paddingY: "20px",
    }),
    doubtUserContainer: defineStyle({
      marginY: "0px",
      marginLeft: { base: "-14px", md: "0px" },
      paddingY: "20px",
    }),
    doubtAssistantContainer: defineStyle({
      marginBottom: "12px",
      marginLeft: { base: "40px", md: "50px", lg: "50px" },
    }),
    practiceAssistantContainer: defineStyle({
      marginY: "12px",
      marginLeft: { base: "40px", md: "50px", lg: "50px" },
    }),
    doubtSubContainer: defineStyle({
      // gridColumn: { base: "1/15", md: "2/14", lg: "3/13" },
      marginBottom: "0px",
    }),
    comprehensionSubContainer: defineStyle({
      marginLeft: { base: "-40px", md: "-50px", lg: "-50px" },
    }),
  };
};
